import { render, staticRenderFns } from "./blank-container.vue?vue&type=template&id=9a0bae8a&"
import script from "./blank-container.vue?vue&type=script&lang=js&"
export * from "./blank-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports